angular.module('omfm').directive('labelsList', LabelsListDirective);

LabelsListDirective.$inject = ['$rootScope'];

function LabelsListDirective($rootScope) {
	return {
		restrict: "EA",
		replace:  true,
		scope: false,
		templateUrl: "/app/omfm/templates/labelsList.html",
	}
}